var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4819 0.123784C12.1818 -0.0412614 11.8182 -0.0412614 11.5181 0.123784L1.53576 5.61406C1.48722 5.63955 1.44103 5.66891 1.3976 5.70173C1.32054 5.75982 1.25339 5.82797 1.19731 5.90351C1.09366 6.04275 1.02539 6.20989 1.00581 6.39162C1.0014 6.43189 0.999439 6.47259 1 6.51352V19H0V24H24V19H23V6.51352C23.0006 6.47258 22.9986 6.43187 22.9942 6.39159C22.9746 6.20984 22.9063 6.04267 22.8026 5.90341C22.7466 5.82792 22.6794 5.7598 22.6024 5.70173C22.559 5.66891 22.5128 5.63954 22.4642 5.61406L12.4819 0.123784ZM18.1068 5.5L12 2.14127L5.89322 5.5H18.1068ZM21 7.5H3V8.5H21V7.5ZM20 10.5H21V19H20V10.5ZM17 10.5H18V19H17V10.5ZM9 12.4996V10.5H15V12.4996C14.1643 11.8719 13.1256 11.5 12 11.5C10.8744 11.5 9.83566 11.8719 9 12.4996ZM6 10.5H7V19H6V10.5ZM3 10.5H4V19H3V10.5ZM9 16.5V19H15V16.5C15 14.8431 13.6569 13.5 12 13.5C10.3431 13.5 9 14.8431 9 16.5ZM2 21V22H22V21H2Z",
    fill: "#80919F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.a45ddc108870e4b628d9a6526aae3c0c.svg";
export { ForwardRef as ReactComponent };